import { render, staticRenderFns } from "./Loca.vue?vue&type=template&id=4573b9c0&"
import script from "./Loca.vue?vue&type=script&lang=js&"
export * from "./Loca.vue?vue&type=script&lang=js&"
import style0 from "./Loca.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports